<template>
  <div class="dialog-wechat-menu-editor-wrapper">
    <el-dialog width="50%" :title="`添加自动回复消息（${user.username}）`" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form ref="form" :rules="formRule" :model="formData">

        <el-form-item label="菜单配置" prop="menu">
          <el-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 15 }"
            placeholder="请输入菜单配置"
            v-model="formData.menu">
          </el-input>
        </el-form-item>

      </el-form>

      <div class="submit-box">
        <el-button
          type="danger"
          @click="onFormSubmit">确定</el-button>
        <el-button @click="onFormCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import wechatAutoReplyApi from '@/api/wechatAutoReplyApi'

export default {
  name: 'DialogWechatMenuEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    wechatAccount: {
      type: Object,
      required: true
    },
    wechatMenu: {
      type: Object,
      required: false
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    }
  },
  data () {
    return {
      formData: {
        userId: '',
        menu: ''
      },
      formRule: {
        menu: [
          { required: true, message: '请输入菜单配置', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async onDialogOpen () {
      if (this.mode === 'update') {
        this.formData = {
          userId: this.user.userid,
          menu: JSON.stringify(this.wechatMenu['selfmenu_info'] || {}, null, '\t')
        }
      } else {
        this.formData = {
          userId: this.user.userId,
          menu: ''
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
      this.$refs['form'].resetFields()
    },

    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()

        let menu = {}
        try {
          menu = JSON.parse(this.formData.menu)
        } catch (err) {
          console.log(err)
        }
        this.$emit('submit', {
          userId: this.formData.userId,
          menu: menu
        })
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.onDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wechat-menu-editor-wrapper {

  .submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogWechatMenuEditor.vue